import React, { Component } from "react"
import ContainerDimensions from "react-container-dimensions"
import { connect } from "../../utils"
import { CarouselList } from "./carouselAnimation"

class CarouselAnimationView extends Component {
  render() {
    const { id, layoutState } = this.props

    return (
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "auto",
          display: "flex",
          width: "100%",
          justifyContent: "center",
          flex: 1,
        }}
      >
        <ContainerDimensions>
          {({ width, height }) => {
            return (
              <CarouselList
                data={layoutState.getItemJS(id).props.values}
                widthContainer={width}
                heightContainer={height}
              />
            )
          }}
        </ContainerDimensions>
      </div>
    )
  }
}

export default connect("layoutState")(CarouselAnimationView)



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/CarouselAnimationView.js